const invertedMessages = {
  'Saviynt Security Manager': 'certs.prelaunch.launch.blocker.title',
  'Launch blocked:': 'certs.prelaunch.launch.blocked.prefix',
  'blocker(s) must be resolved before launching.':
    'certs.prelaunch.launch.blocker.subtitle',
  Close: 'certs.prelaunch.close.button',
};

export default invertedMessages;
